import * as THREE from "three";
import { Settings, GetSettings } from "./Settings";

exports.Unify = function(unify) {
  this.unify_id = "enemyController";

  const settings = GetSettings();
  const enemies = [];
  const enemiesGroup = new THREE.Group();
  enemiesGroup.name = "enemies";

  let terrainModule;
  let gameLogic;
  let worldState = 0;

  let frameCount_Distance = 0;
  let mapMax = settings.terrainsize / 2 - settings.terrainSafeMargin;

  unify.assetLoader.loadFBX("./objects/enemy_v01.fbx");

  // AWAKE
  this.awake = () => {
    gameLogic = unify.getModules().gameLogic;
    terrainModule = unify.getModules().terrain;
    unify.addNewAsset("enemies", []);
  };

  // START
  this.start = () => {
    // create enemies
    for (let i = 0; i < settings.numberOfEnemies; i++) {
      enemies[i] = new Enemy(unify, settings);

      // add to scene, assets
      enemiesGroup.add(enemies[i].object);
      unify.getAssets().enemies.push(enemies[i].object);

      // random start position
      if (gameLogic) enemies[i].object.position.copy(gameLogic.RandomSpawnPoint());
    }
    unify.scene.add(enemiesGroup);

    // start state
    this.updateEnemyStates(0);
  };

  // UPDATE
  this.update = deltaTime => {
    // call frame update on active enemies
    for (let i = 0; i < enemies.length; i++) {
      enemies[i].update(deltaTime);
    }
    // interval update distance to player checks
    if (frameCount_Distance == settings.enemyDistanceUpdateInterval) {
      for (let i = 0; i < enemies.length; i++) {
        enemies[i].updateBehavior();
      }
      frameCount_Distance = 0;
    }
    frameCount_Distance++;
  };

  // Enemy Object ********
  function Enemy(unify, settings) {
    let constraints = new THREE.Vector3(settings.playAreaSize / 2, 15, settings.playAreaSize / 2);
    // parent
    this.object = new THREE.Object3D();
    this.object.name = "enemy";
    // rot helper
    const rotationHelper = new THREE.Object3D();
    rotationHelper.name = "enemyRotationHelper";
    // mesh
    //const mesh = main.create.cone();
    const mesh = unify.instantiate("enemy_v01", true);
    this.object.add(mesh);
    mesh.name = "enemyMesh";
    mesh.scale.set(0.008, 0.008, 0.008);

    //mesh.rotateX(1.57);
    // state
    let hasAttacked = false;
    let currentState = 0;
    // vars
    let moveTarget = new THREE.Vector3(0, 0, 0);
    let toPlayer = new THREE.Vector3(0, 0, 0);
    let toPoint = new THREE.Vector3(0, 0, 0);

    let player = unify.assets.player;
    let gameLogic = unify.modules.gameLogic;
    let distanceToPlayer = 100;
    let newDirectionTime = 0;
    let newDirectionCounter = 0;
    let newTargetTime = 0;
    let newTargetCounter = 0;
    let colorFlasher = null;
    let colorState = false;
    let currentMoveSpeed = 0;
    let oldY = 0;
    let newY = 0;
    let yLerp = 0;
    let rLerp = 0;

    // reset turn, target timers
    this.reset = () => {
      newDirectionCounter = 0;
      newTargetCounter = 0;
    };

    // enemy internal update
    this.update = deltaTime => {
      mesh.userData.mixer.update(deltaTime);
      if (newTargetCounter >= newTargetTime) {
        this.setMoveTarget();
        newTargetCounter = 0;
        newTargetTime = settings.agitation[currentState] * ((settings.agitationDelta / 100) * Math.random());
      }

      // move forward
      this.object.translateZ(deltaTime * currentMoveSpeed);
      this.boundsCheck();

      // rotate
      rLerp += deltaTime;
      this.object.quaternion.slerp(rotationHelper.quaternion, rLerp * 0.1);

      // y height
      yLerp += deltaTime;
      this.object.position.y = unify.utilities.lerp(oldY, moveTarget.y, yLerp * 0.5);
      //clamp to terrain min

      let minY = terrainModule ? terrainModule.getTerrainHeight(this.object.position.x, this.object.position.z) + 1 : 0;
      if (this.object.position.y < minY) {
        this.object.position.y = minY;
        moveTarget.y += 1;
      }

      newDirectionCounter += deltaTime;
      newTargetCounter += deltaTime;
    };

    // turns object toward moveTarget
    this.setTargetDirection = target => {
      rotationHelper.position.copy(this.object.position);
      rotationHelper.lookAt(target);
      rLerp = 0;
    };

    // sets a new moveTarget based on state
    this.setMoveTarget = () => {
      oldY = this.object.position.y;
      yLerp = 0;

      switch (currentState) {
        case 0: // neutral
          moveTarget = unify.modules.gameLogic ? unify.modules.gameLogic.RandomSpawnPoint() : new THREE.Vector3();
          moveTarget.y = terrainModule ? terrainModule.getTerrainHeight(moveTarget.x, moveTarget.z) + 1 : 0;
          moveTarget.y += Math.random() * constraints.y;
          break;
        case 1: // player powerUp - run away
          let newPoint = pointOnCircle(100, player.position);
          toPlayer.subVectors(this.object.position, player.position);
          toPoint.subVectors(this.object.position, newPoint);
          toPlayer.normalize();
          toPoint.normalize();

          if (toPlayer.dot(toPoint) >= 0) {
            moveTarget.x = -newPoint.x;
            moveTarget.z = -newPoint.z;
            moveTarget.y = terrainModule ? terrainModule.getTerrainHeight(moveTarget.x, moveTarget.z) + 1 : 0;
          } else {
            moveTarget = newPoint;
          }
          break;
        case 2: // hunt player
          if (getDotToPlayer(this) > 0.75 && distanceToPlayer < 60) {
            moveTarget.copy(player.position);
            currentMoveSpeed = settings.enemyMoveSpeed[currentState];
          } else {
            moveTarget = pointOnCircle(40, targetForwardPoint(player, -75));
            moveTarget.y += Math.random() * constraints.y;
            currentMoveSpeed = settings.enemyMoveSpeed[currentState] * 5;
          }
          break;
      }
      this.setTargetDirection(moveTarget);
      return moveTarget;
    };

    // return timed bool
    this.tryAttack = () => {
      if (hasAttacked) return false;
      else {
        setTimeout(function() {
          hasAttacked = false;
        }, settings.attackRate);
        hasAttacked = true;
        return true;
      }
    };

    // look at target
    this.turnImmediate = target => {
      rotationHelper.position.copy(this.object.position);
      rotationHelper.lookAt(target);
      this.object.quaternion.copy(rotationHelper.quaternion);
    };

    this.boundsCheck = () => {
      // if hit bounds, immediately turn towards origin
      if (
        this.object.position.x >= constraints.x ||
        this.object.position.x <= -constraints.x ||
        this.object.position.z >= constraints.z ||
        this.object.position.z <= -constraints.z
      ) {
        // moveTarget = new THREE.Vector3();
        this.turnImmediate(moveTarget);
      }
    };

    // interaction
    this.updateBehavior = () => {
      distanceToPlayer = this.object.position.distanceTo(player.position);

      if (currentState == 0) {
        if (getDotToPlayer(this) > 0.7 && distanceToPlayer < settings.enemyAutoAttackDistance) {
          this.setState(2);
        }
      }
      switch (currentState) {
        case 0: // neutral
          break;
        case 1: // scared
          if (distanceToPlayer < settings.enemyKillDistance) {
            unify.assets.playerStats.kills++;
            // send to a new random spawn point
            this.object.position.copy(gameLogic.RandomSpawnPoint());

            gameLogic.glitch(300);
            if (unify.modules.sounds) unify.modules.sounds.play(3);
            gameLogic.countdown += settings.enemyKillAddTime;
          }
          break;
        case 2: // aggro
          if (distanceToPlayer < settings.enemyDamageDistance && getDotToPlayer(this) > -0.9) {
            if (this.tryAttack()) {
              //successful attack
              gameLogic.playerHealth(settings.enemyAttackDamage);
              gameLogic.glitch(600);
              if (unify.modules.sounds) unify.modules.sounds.play(2);
              this.object.position.copy(gameLogic.RandomSpawnPoint());
              this.setState(worldState);
              distanceToPlayer = 100;
            }
          }
          break;
      }
    };

    this.setState = state => {
      currentState = state;
      currentMoveSpeed = settings.enemyMoveSpeed[currentState];
      // set enemy colors/animations
      switch (state) {
        case 0: // neutral
          if (colorFlasher != null) clearInterval(colorFlasher);
          colorFlasher = null;
          unify.objectTools.setColorHex(mesh, settings.enemyColors[currentState]);
          mesh.userData.animations.evilMode.stop();
          break;
        case 1: // player powerUp
          mesh.userData.animations.evilMode.stop();
          if (colorFlasher != null) clearInterval(colorFlasher);
          colorFlasher = null;
          colorFlasher = setInterval(colorToggle, 250);
          break;
        case 2: // hunt player
          // animation
          mesh.userData.animations.evilMode.play();
          mesh.userData.animations.evilMode.time = Math.random() * mesh.userData.animations.evilMode._clip.duration;
          // color
          if (colorFlasher != null) clearInterval(colorFlasher);
          colorFlasher = null;
          unify.objectTools.setColorHex(mesh, settings.enemyColors[currentState]);
          break;
      }
      this.reset();
    };

    // color toggle
    const colorToggle = () => {
      if (colorState) {
        unify.objectTools.setColorHex(mesh, settings.enemyColors[currentState]);
        colorState = !colorState;
      } else {
        unify.objectTools.setColorHex(mesh, 0xffffff);
        colorState = !colorState;
      }
    };

    // End Enemy Object ========================================================
  }

  // set states on all enemies
  this.updateEnemyStates = stateID => {
    console.log("enemy states updated");
    if (stateID < 0) stateID = 0;
    for (let i = 0; i < enemies.length; i++) {
      enemies[i].setState(stateID);
    }
    worldState = stateID;
  };

  const pointOnCircle = (radius, centerPoint) => {
    let angle = Math.random() * Math.PI * 2;
    let point = new THREE.Vector3(0, 0, 0);
    point.x = Math.cos(angle) * radius;
    point.z = Math.sin(angle) * radius;
    point.add(centerPoint);
    if (Math.abs(point.x) > mapMax) point.x = point.x - Math.abs(point.x - mapMax);
    if (Math.abs(point.z) > mapMax) point.z = point.z - Math.abs(point.z - mapMax);
    return point;
  };

  let targetDirection = new THREE.Vector3(0, 0, 0);
  const targetForwardPoint = (object3D, distance) => {
    targetDirection = object3D.getWorldDirection(targetDirection);
    let targetLeadpoint = targetDirection.multiplyScalar(distance);
    targetLeadpoint.add(object3D.position);
    return targetLeadpoint;
  };

  let tempVec = new THREE.Vector3();
  let playerPosition = new THREE.Vector3();
  let forwardVec = new THREE.Vector3();
  const getDotToPlayer = enemy => {
    unify.assets.player.getWorldDirection(tempVec);
    playerPosition.copy(unify.assets.player.position);
    forwardVec = forwardVec.subVectors(playerPosition, enemy.object.position).normalize();
    return tempVec.dot(forwardVec);
  };
};
